import { z } from "zod";

export const CNS_TOOL_EXECUTION_ARTIFACT_TYPE = "cns-tool-execution";
export const CNS_TOOL_EXECUTION_ARTIFACT_VERSION = 1;

const nonBlankStringSchema = z
  .string()
  .min(1)
  .refine((value) => value.trim().length > 0, "Must not be blank");

/**
 * Version-one presentation metadata for a governed MCP execution.
 *
 * The descriptor is intentionally plugin-neutral: labels are supplied by the backend catalog,
 * while stable keys remain available for navigation and diagnostics.
 */
export const cnsToolExecutionArtifactSchema = z
  .object({
    type: z.literal(CNS_TOOL_EXECUTION_ARTIFACT_TYPE),
    version: z.literal(CNS_TOOL_EXECUTION_ARTIFACT_VERSION),
    executionKind: z.literal("mcp"),
    agentName: nonBlankStringSchema,
    agentLabel: nonBlankStringSchema,
    plugin: z
      .object({
        key: nonBlankStringSchema,
        label: nonBlankStringSchema,
      })
      .strict(),
    tool: z
      .object({
        key: nonBlankStringSchema,
        label: nonBlankStringSchema,
      })
      .strict(),
  })
  .strict();

export type CnsToolExecutionArtifact = z.infer<typeof cnsToolExecutionArtifactSchema>;

/** Returns a validated execution artifact or null for unrelated tool metadata. */
export function parseCnsToolExecutionArtifact(value: unknown): CnsToolExecutionArtifact | null {
  const parsed = cnsToolExecutionArtifactSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}

